import { VenueConfirmedShows, VenueUnconfirmedShows } from '@features';
import { Stack } from '@mantine/core';

export const VenueDetailsShowsPage: React.FC = () => {
  return (
    <Stack py="md" gap="xl">
      <VenueConfirmedShows />
      <VenueUnconfirmedShows />
    </Stack>
  );
};
